module.exports = __webpack_public_path__ + "img/img15.8464e801.jpg";